export default __webpack_public_path__ + "images/models/4b08c8a01e510888bb28b6a3eb9af535.glb";